import { frontendURL } from '../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../featureFlags';
import PainelIndex from './Index.vue';
import AppointmentsPage from './agendamentos/AppointmentsPage.vue';
import ConfiguracoesIndex from './configuracoes/Index.vue';
import HumanAttentionPage from './atendimentos-humanos/HumanAttentionPage.vue';

const meta = {
  permissions: ['administrator', 'agent'],
  featureFlag: FEATURE_FLAGS.PAINEL,
};
const adminMeta = {
  permissions: ['administrator'],
  featureFlag: FEATURE_FLAGS.PAINEL,
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/painel'),
      name: 'account_painel',
      meta,
      component: PainelIndex,
    },
    {
      path: frontendURL('accounts/:accountId/painel/agendamentos'),
      name: 'painel_appointments',
      meta: { ...meta, featureFlag: FEATURE_FLAGS.AGENDAMENTOS },
      component: AppointmentsPage,
    },
    {
      path: frontendURL('accounts/:accountId/painel/configuracoes'),
      name: 'painel_configuracoes',
      meta: adminMeta,
      component: ConfiguracoesIndex,
    },
    {
      path: frontendURL('accounts/:accountId/painel/atendimentos-humanos'),
      name: 'painel_human_attention',
      meta,
      component: HumanAttentionPage,
    },
  ],
};
